import { render, staticRenderFns } from "./MaterialCard.html?vue&type=template&id=7b4d2b0e&scoped=true&"
import script from "./MaterialCard.ts?vue&type=script&lang=ts&"
export * from "./MaterialCard.ts?vue&type=script&lang=ts&"
import style0 from "./MaterialCard.scss?vue&type=style&index=0&id=7b4d2b0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d2b0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardActions,VDivider,VIcon,VSheet})
